import React, { useState } from 'react';
import { useFeedback } from '../../contexts/FeedbackContext';
import { FeedbackQuestionnaire } from './';

const FeedbackSystem = () => {
  const [showQuestionnaire, setShowQuestionnaire] = useState(false);

  const handleOpenQuestionnaire = () => {
    setShowQuestionnaire(true);
  };

  const handleCloseQuestionnaire = () => {
    setShowQuestionnaire(false);
  };

  return (
    <FeedbackQuestionnaire 
      isOpen={showQuestionnaire} 
      onClose={handleCloseQuestionnaire} 
    />
  );
};

export default FeedbackSystem;